import { LOGIN, LOGOUT } from './constants'

export const logoutAuth = () => (dispatch: any) => {
    dispatch({
        type: LOGOUT,
        payload: undefined
    });
};

export const loginAuth = (user: any) => (dispatch: any) => {
    dispatch({
        type: LOGIN,
        payload: user,
    });
};

